<template>
  <v-data-table
    :headers="headers"
    :items="flattenedData"
    class="elevation-0"
    :items-per-page="-1"
    hide-default-footer
    no-data-text="Chưa có dữ liệu"
    disable-sort
  >
    <template v-slot:[`item.title`]="{ item }">
      <div :style="{ paddingLeft: `${item.level * 20}px` }">
        {{ `${item.index || ''}. ${item.title}` }}
      </div>
    </template>
    <template v-slot:[`item.divisions`]="{ item }">
      <EducationTableProgram :divisions="item.divisions" />
    </template>
    <!-- <template v-slot:[`item.actions`]="{ item }">
          <DivisionActions v-if="!(item.config && item.config.default)" :selected="item" />
        </template> -->
  </v-data-table>
</template>

<script>
import { mapState } from 'vuex'
import DivisionActions from '@/modules/division/DivisionListActions.vue'
import EducationTableProgram from './EducationTableProgram.vue'

export default {
  components: {
    DivisionActions,
    EducationTableProgram,
  },
  data() {
    return {
      headers: [
        { text: 'Bộ môn', value: 'title' },
        { text: 'Chương trình đào tạo', value: 'divisions' },
      ],
      data: [],
    }
  },
  computed: {
    ...mapState({
      divisions(state) {
        return state['division'].divisionsWithAcademicLevel
      },
    }),
    flattenedData() {
      const flatten = (items, level = 0) => {
        return items.reduce((acc, item) => {
          acc.push({ ...item, level })
          if (item.children) {
            acc = acc.concat(flatten(item.children, level + 1))
          }
          return acc
        }, [])
      }
      return flatten(this.data)
    },
  },
  methods: {},
  watch: {
    divisions: {
      handler(val) {
        if (Array.isArray(val)) {
          this.data = val
        }
      },
      immediate: true,
      deep: true,
    },
  },
}
</script>

<style></style>
